export default __webpack_public_path__ + "static/media/icon-public-holiday.6c7c8a30.svg";